module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-arrow-back"
    }
  }), _vm._v("\n      返回\n    ")], 1), _vm._v(" "), _c('h1', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("学生信息详情")]), _vm._v(" "), _c('Tabs', {
    attrs: {
      "type": "card",
      "animated": false
    },
    on: {
      "on-click": _vm.onTabClick
    },
    model: {
      value: (_vm.tabName),
      callback: function($$v) {
        _vm.tabName = $$v
      },
      expression: "tabName"
    }
  }, [_c('TabPane', {
    attrs: {
      "label": "基本信息",
      "name": "one"
    }
  }, [_c('Form', {
    ref: "userInfoForm",
    staticClass: "form",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.userRule
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    staticStyle: {
      "border-right": "1px dotted #ddd"
    },
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin": "0 0 20px 10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("基本信息")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 14
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 20
    }
  }, [_c('span', [_c('input', {
    staticStyle: {
      "width": "0px",
      "height": "0px",
      "padding": "0"
    },
    attrs: {
      "type": "text",
      "name": "enName"
    }
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "width": "0px",
      "height": "0px",
      "padding": "0"
    },
    attrs: {
      "type": "password",
      "name": "password"
    }
  })]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "英文名字："
    }
  }, [_c('Input', {
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: (_vm.formData.enName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "enName", $$v)
      },
      expression: "formData.enName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "密码："
    }
  }, [_c('Input', {
    attrs: {
      "type": "password",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.formData.password),
      callback: function($$v) {
        _vm.$set(_vm.formData, "password", $$v)
      },
      expression: "formData.password"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "中文名字："
    }
  }, [_c('Input', {
    attrs: {
      "name": "cnName",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.formData.cnName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cnName", $$v)
      },
      expression: "formData.cnName"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "20px"
    },
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 10
    }
  }, [_c('a', {
    on: {
      "click": _vm.openStudentPage
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px",
      "border": "1px solid #f0f0f0",
      "margin": "10px auto"
    },
    attrs: {
      "src": _vm.totalImageUrl
    }
  })]), _vm._v(" "), _c('single-one-pic-upload', {
    attrs: {
      "text": _vm.text
    },
    on: {
      "on-file-change": _vm.handleResult
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "年龄：",
      "prop": "age"
    }
  }, [_c('Input', {
    attrs: {
      "name": "age"
    },
    on: {
      "on-change": _vm.calcBirthdayFromAge
    },
    model: {
      value: (_vm.formData.age),
      callback: function($$v) {
        _vm.$set(_vm.formData, "age", $$v)
      },
      expression: "formData.age"
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "性别："
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.sex),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sex", $$v)
      },
      expression: "formData.sex"
    }
  }, _vm._l((_vm.$constant.sex), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "年级："
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.grade),
      callback: function($$v) {
        _vm.$set(_vm.formData, "grade", $$v)
      },
      expression: "formData.grade"
    }
  }, _vm._l((_vm.$constant.grade), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "生日："
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "format": "yyyy-MM-dd",
      "value-format": "timestamp"
    },
    on: {
      "change": _vm.calcAgeFromBirthday
    },
    model: {
      value: (_vm.formData.birthday),
      callback: function($$v) {
        _vm.$set(_vm.formData, "birthday", _vm._n($$v))
      },
      expression: "formData.birthday"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "生源地："
    }
  }, [_c('v-distpicker', {
    attrs: {
      "province": _vm.formData.province,
      "city": _vm.formData.city,
      "area": _vm.formData.block,
      "placeholders": _vm.placeholders
    },
    on: {
      "province": _vm.onSelectedProvince,
      "city": _vm.onSelectedCity,
      "area": _vm.onSelectedArea
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 16,
      "md": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "英语学习经历："
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formData.learnEnglishTime),
      callback: function($$v) {
        _vm.$set(_vm.formData, "learnEnglishTime", $$v)
      },
      expression: "formData.learnEnglishTime"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("不足三个月")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("一年左右")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("一年以上")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("没有学习过英语")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "是否接触过外教："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.haveContactForeignTeacher),
      callback: function($$v) {
        _vm.$set(_vm.formData, "haveContactForeignTeacher", $$v)
      },
      expression: "formData.haveContactForeignTeacher"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "-1"
    }
  }, [_c('span', [_vm._v("否")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("是")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_c('span', [_vm._v("不确定")])])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "允许修改请假规则："
    }
  }, [_c('i-switch', {
    attrs: {
      "size": "large"
    },
    on: {
      "on-change": _vm.handleEnabledRuleChange
    },
    model: {
      value: (_vm.formData.enabledRule),
      callback: function($$v) {
        _vm.$set(_vm.formData, "enabledRule", $$v)
      },
      expression: "formData.enabledRule"
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "支持多级别排课："
    }
  }, [_c('i-switch', {
    attrs: {
      "value": _vm.formData.stars === 2,
      "size": "large"
    },
    on: {
      "on-change": _vm.handleMultiLevelScheduleChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "支持自主约课："
    }
  }, [_c('i-switch', {
    attrs: {
      "value": _vm.formData.tchIdCopy === 1,
      "size": "large"
    },
    on: {
      "on-change": _vm.handleSelfBookingChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "允许阶段测："
    }
  }, [_c('i-switch', {
    attrs: {
      "value": _vm.summativeEnabled,
      "size": "large"
    },
    on: {
      "on-change": _vm.handleSummativeEnabledChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "哈佛外教课权限："
    }
  }, [_c('i-switch', {
    attrs: {
      "value": _vm.harvardForeignEnabled,
      "size": "large"
    },
    on: {
      "on-change": _vm.handleHarvardForeignAuthChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("是")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("否")])])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "阶段测蓝图："
    }
  }, [_c('Select', {
    attrs: {
      "value": _vm.summativeBlueprintId,
      "placeholder": "请选择阶段测蓝图",
      "transfer": ""
    },
    on: {
      "on-change": _vm.handleSummativeBlueprintChange
    }
  }, _vm._l((_vm.summativeBlueprints), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.segment && item.versionNo ? item.segment + ' / ' + item.versionNo : item.id))])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "家庭经济情况："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.familyEconomicSituation),
      callback: function($$v) {
        _vm.$set(_vm.formData, "familyEconomicSituation", $$v)
      },
      expression: "formData.familyEconomicSituation"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("非常好")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("一般")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("不是很好")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_c('span', [_vm._v("不确定")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "是否重视英语学习："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.attentionEnglish),
      callback: function($$v) {
        _vm.$set(_vm.formData, "attentionEnglish", $$v)
      },
      expression: "formData.attentionEnglish"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("是")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("否")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_c('span', [_vm._v("不确定")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "接通状态："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.connectionStatus),
      callback: function($$v) {
        _vm.$set(_vm.formData, "connectionStatus", $$v)
      },
      expression: "formData.connectionStatus"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("未拨打")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("拨打未接")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("拨打接通")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "4"
    }
  }, [_c('span', [_vm._v("无效资源")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Form-item', [_c('span', [_vm._v("绘本VIP:" + _vm._s(_vm.formData.vipDesc || '未开通'))]), _vm._v(" "), (_vm.appVersionData.versionName) ? _c('span', {
    staticStyle: {
      "margin-left": "30px"
    }
  }, [_vm._v("APP版本信息：" + _vm._s(_vm.appVersionTypeText) + "/"), _c('span', {
    style: ({
      color: _vm.appVersionData.versionName === '7.0.5' ? '#19be6b' : '#ed4014'
    })
  }, [_vm._v(_vm._s(_vm.appVersionData.versionName === '7.0.5' ? '最新版' : '旧版本'))]), _vm._v("/" + _vm._s(_vm.appVersionData.loginTime ? _vm.$moment(_vm.appVersionData.loginTime).format('YYYY-MM-DD HH:mm') : '-'))]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin": "0 0 20px 10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("联系方式")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "学生ID："
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.formData.uid))])])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "手机号码：",
      "prop": "mobile"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "220px"
    },
    model: {
      value: (_vm.formData.mobile),
      callback: function($$v) {
        _vm.$set(_vm.formData, "mobile", $$v)
      },
      expression: "formData.mobile"
    }
  }), _vm._v(" "), _c('i-switch', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "value": _vm.formData.mobileRemind === 1 || !(_vm.formData.remarkMobile || '').replace(/[,\s]/g, ''),
      "disabled": !(_vm.formData.remarkMobile || '').replace(/[,\s]/g, ''),
      "size": "large"
    },
    on: {
      "on-change": _vm.handleMobileRemindChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("提醒")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("关")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#999"
    }
  }, [_vm._v("（开关打开则上课短信/电话提醒发到该号码；没有备用号码时始终提醒该号码）")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "备用手机号码："
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "220px"
    },
    model: {
      value: (_vm.formData.remarkMobile),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remarkMobile", $$v)
      },
      expression: "formData.remarkMobile"
    }
  }), _vm._v(" "), _c('i-switch', {
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "value": _vm.formData.remarkMobileRemind === 1,
      "size": "large"
    },
    on: {
      "on-change": _vm.handleRemarkMobileRemindChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("提醒")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("关")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#999"
    }
  }, [_vm._v("（仅用于上课提醒，多个号码用英文逗号隔开；开关打开则提醒发到该号码，两个开关都开则两个号码都提醒）")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "是否允许电话提醒："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.allowCallReminder),
      callback: function($$v) {
        _vm.$set(_vm.formData, "allowCallReminder", $$v)
      },
      expression: "formData.allowCallReminder"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_c('span', [_vm._v("是")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "-1"
    }
  }, [_c('span', [_vm._v("否")])])], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "是否允许短信提醒："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.allowSmsReminder),
      callback: function($$v) {
        _vm.$set(_vm.formData, "allowSmsReminder", $$v)
      },
      expression: "formData.allowSmsReminder"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "0"
    }
  }, [_c('span', [_vm._v("是")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "-1"
    }
  }, [_c('span', [_vm._v("否")])])], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "课前电话提醒："
    }
  }, [_c('i-switch', {
    attrs: {
      "value": _vm.formData.beforeClassCall === 1,
      "size": "large"
    },
    on: {
      "on-change": _vm.handleBeforeClassCallChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("开")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("关")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#999"
    }
  }, [_vm._v("（打开且“允许电话提醒”为是时，课前提醒会打电话）")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "课前提醒时间："
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "如 2,24"
    },
    model: {
      value: (_vm.formData.remindHours),
      callback: function($$v) {
        _vm.$set(_vm.formData, "remindHours", $$v)
      },
      expression: "formData.remindHours"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "12px",
      "color": "#999"
    }
  }, [_vm._v("（默认课前1小时提醒；可再填小时数，多个用英文逗号隔开）")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "号码对应人："
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formData.phoneRole),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phoneRole", $$v)
      },
      expression: "formData.phoneRole"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("父亲")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("母亲")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("其他")])])], 1)], 1)], 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addContact
    }
  }, [_vm._v("添加联系人")]), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "userContacts"
    }
  }, _vm._l((_vm.formData.userContacts), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('Row', {
      attrs: {
        "gutter": 16
      }
    }, [_c('Form-item', {
      staticStyle: {
        "margin-top": "10px"
      }
    }, [_c('i-col', {
      attrs: {
        "xs": 24,
        "sm": 10
      }
    }, [_c('Input', {
      staticStyle: {
        "margin-bottom": "5px"
      },
      attrs: {
        "placeholder": "姓名"
      },
      model: {
        value: (_vm.formData.userContacts[index].name),
        callback: function($$v) {
          _vm.$set(_vm.formData.userContacts[index], "name", $$v)
        },
        expression: "formData.userContacts[index].name"
      }
    })], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "xs": 24,
        "sm": 10
      }
    }, [_c('Input', {
      staticStyle: {
        "margin-bottom": "5px"
      },
      attrs: {
        "placeholder": "手机号码",
        "number": true
      },
      model: {
        value: (_vm.formData.userContacts[index].mobile),
        callback: function($$v) {
          _vm.$set(_vm.formData.userContacts[index], "mobile", $$v)
        },
        expression: "formData.userContacts[index].mobile"
      }
    })], 1), _vm._v(" "), _c('i-col', {
      attrs: {
        "xs": 24,
        "sm": 4
      }
    }, [_c('Button', {
      staticStyle: {
        "width": "100%"
      },
      on: {
        "click": function($event) {
          return _vm.deleteContact(index)
        }
      }
    }, [_vm._v("删除")])], 1)], 1)], 1)], 1)
  }), 0), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "微信账号：",
      "prop": "wechatAccount"
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%"
    },
    model: {
      value: (_vm.formData.wechatAccount),
      callback: function($$v) {
        _vm.$set(_vm.formData, "wechatAccount", $$v)
      },
      expression: "formData.wechatAccount"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "地址："
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%",
      "height": "60px"
    },
    attrs: {
      "type": "textarea",
      "autosize": true
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "个人信息备注："
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "100%",
      "height": "60px"
    },
    attrs: {
      "type": "textarea",
      "autosize": true
    },
    model: {
      value: (_vm.formData.infoRemark),
      callback: function($$v) {
        _vm.$set(_vm.formData, "infoRemark", $$v)
      },
      expression: "formData.infoRemark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "fixed-class-require"
  }, [_c('div', {
    staticClass: "fixed-class-require-title"
  }, [_vm._v("固定上课需求")]), _vm._v(" "), _c('Input', {
    attrs: {
      "type": "textarea",
      "maxlength": 500,
      "autosize": {
        minRows: 3,
        maxRows: 6
      },
      "placeholder": "一行一个要求，例如：不放儿歌"
    },
    model: {
      value: (_vm.fixedClassRequire),
      callback: function($$v) {
        _vm.fixedClassRequire = $$v
      },
      expression: "fixedClassRequire"
    }
  }), _vm._v(" "), (_vm.fixedRequireLines.length) ? _c('div', {
    staticClass: "fixed-class-require-tags"
  }, _vm._l((_vm.fixedRequireLines), function(item, index) {
    return _c('Tag', {
      key: 'zh-' + index,
      attrs: {
        "color": "blue"
      }
    }, [_vm._v(_vm._s(item))])
  }), 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "fixed-class-require-en"
  }, [_vm._v("老师看到的英文")]), _vm._v(" "), (_vm.fixedRequireEnLines.length) ? _c('div', {
    staticClass: "fixed-class-require-tags"
  }, _vm._l((_vm.fixedRequireEnLines), function(item, index) {
    return _c('Tag', {
      key: 'en-' + index,
      attrs: {
        "color": "green"
      }
    }, [_vm._v(_vm._s(item))])
  }), 1) : _c('div', {
    staticClass: "fixed-class-require-empty"
  }, [_vm._v("暂无")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.fixedClassRequireSaving
    },
    on: {
      "click": _vm.saveFixedClassRequire
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('div', {
    staticClass: "fixed-class-require-tip"
  }, [_vm._v("一行一个要求。含中文会按行翻译成英文给老师看；清空后保存会去掉老师端标记。最多 500 字。")])], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px dotted #ddd",
      "margin-bottom": "20px"
    }
  }), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    staticStyle: {
      "border-right": "1px dotted #ddd"
    },
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("学生来源标签")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 10
    }
  }, [_c('Form-item', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "label-width": _vm.auto,
      "label": "注册渠道："
    }
  }, [_c('Input', {
    attrs: {
      "name": "regType",
      "disabled": ""
    },
    model: {
      value: (_vm.formData.regType),
      callback: function($$v) {
        _vm.$set(_vm.formData, "regType", $$v)
      },
      expression: "formData.regType"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "付费渠道："
    }
  }, _vm._l((_vm.$constant.studentTags), function(item) {
    return _c('RadioGroup', {
      key: item.code,
      model: {
        value: (_vm.formData.payCanal),
        callback: function($$v) {
          _vm.$set(_vm.formData, "payCanal", $$v)
        },
        expression: "formData.payCanal"
      }
    }, [_c('Radio', {
      attrs: {
        "label": item.code
      }
    }, [_c('span', [_vm._v(_vm._s(item.text))])])], 1)
  }), 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "1px dotted #ddd"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("课顾电话跟进")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "20px"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "12px",
      "margin-left": "10px"
    }
  }, [_vm._v("意向等级：")]), _vm._v(" "), _c('RadioGroup', {
    model: {
      value: (_vm.formData.intentLevel),
      callback: function($$v) {
        _vm.$set(_vm.formData, "intentLevel", $$v)
      },
      expression: "formData.intentLevel"
    }
  }, [_c('Radio', {
    attrs: {
      "label": ""
    }
  }, [_c('span', [_vm._v("不论")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("高意向")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("意向一般")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3"
    }
  }, [_c('span', [_vm._v("待跟进")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "4"
    }
  }, [_c('span', [_vm._v("无效资源")])])], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "gutter": 16
    }
  }, [_c('i-col', {
    attrs: {
      "xs": 24,
      "sm": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": _vm.auto,
      "label": "未分班主任提醒："
    }
  }, [_c('i-switch', {
    attrs: {
      "value": _vm.formData.noStudyAdviserRemind === 1,
      "size": "large"
    },
    on: {
      "on-change": _vm.handleNoStudyAdviserRemindChange
    }
  }, [_c('span', {
    attrs: {
      "slot": "open"
    },
    slot: "open"
  }, [_vm._v("开")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "close"
    },
    slot: "close"
  }, [_vm._v("关")])])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    staticStyle: {
      "border-bottom": "1px dotted #ddd"
    },
    attrs: {
      "xs": 24,
      "sm": 24,
      "md": 12
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "10px",
      "margin-bottom": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("学生属性标签")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, _vm._l((_vm.userModal), function(val, key) {
    return _c('span', {
      key: key,
      staticStyle: {
        "margin-left": "20px",
        "font-size": "14px",
        "display": "block"
      }
    }, [_vm._v("\n               " + _vm._s(key) + ":\n               "), (val != null) ? _c('span', _vm._l((val), function(item) {
      return _c('Tag', {
        key: item,
        staticStyle: {
          "margin-left": "10px"
        },
        attrs: {
          "color": "#80848f"
        }
      }, [_vm._v(_vm._s(item))])
    }), 1) : _c('span', [_vm._v("无")])])
  }), 0)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "telephone",
    staticStyle: {
      "text-align": "center",
      "margin": "20px 0"
    }
  }, [_c('Button', {
    staticStyle: {
      "background-color": "#007bff",
      "color": "white",
      "font-size": "14px",
      "padding": "5px 5px",
      "border-radius": "5px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.dialTel
    }
  })], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-bottom": "15px",
      "margin-left": "10px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("通话记录")])], 1), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.callRecordTitle,
      "data": _vm.callRecordData,
      "reload": _vm.reload
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "footer",
    staticStyle: {
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('Button', {
    staticStyle: {
      "width": "40%",
      "margin": "0 10px"
    },
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.insertLoading
    },
    on: {
      "click": _vm.addStudent
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('Button', {
    staticClass: "cancel",
    staticStyle: {
      "width": "40%",
      "margin": "0 10px"
    },
    attrs: {
      "type": "primary",
      "size": "large"
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "Follow Up",
      "name": "two"
    }
  }, [_c('Form', {
    ref: "followForm",
    staticClass: "form",
    attrs: {
      "model": _vm.followFormData,
      "rules": _vm.followRule
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("follow up")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生：",
      "label-width": 120
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.followFormData.id) + " -- " + _vm._s(_vm.followFormData.nickname))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.followFormData.adviserName))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "3"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.followFormData.studyAdviserName))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "9"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "绑定老师：",
      "label-width": 80
    }
  }, _vm._l((_vm.followFormData.tchNames), function(tchName) {
    return _c('el-tag', {
      staticStyle: {
        "margin-right": "2px"
      }
    }, [_vm._v(_vm._s(tchName))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "内容：",
      "prop": "content",
      "label-width": 120
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入..."
    },
    model: {
      value: (_vm.followFormData.content),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "content", $$v)
      },
      expression: "followFormData.content"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态：",
      "prop": "traceStatus",
      "label-width": 120
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.changeFollow
    },
    model: {
      value: (_vm.followFormData.traceStatus),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "traceStatus", $$v)
      },
      expression: "followFormData.traceStatus"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("高跟进")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("跟进中")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("跟进低")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("无意向")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("多次联系不到")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("注册备注")])], 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 50,
      "prop": "traceItem"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.followFormData.traceItem),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "traceItem", $$v)
      },
      expression: "followFormData.traceItem"
    }
  }, _vm._l((_vm.followList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.text) + "\n                  ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), (_vm.followFormData.traceStatus == 100 || _vm.followFormData.traceStatus == '100') ? _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传截图",
      "label-width": 120
    }
  }, [_c('multiple-image-upload', {
    attrs: {
      "num": 100
    },
    model: {
      value: (_vm.followFormData.files),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "files", $$v)
      },
      expression: "followFormData.files"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系时间：",
      "prop": "nextDate",
      "label-width": 120
    }
  }, [_c('DatePicker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.changeDate
    },
    model: {
      value: (_vm.nextDate),
      callback: function($$v) {
        _vm.nextDate = $$v
      },
      expression: "nextDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "对老师要求：",
      "label-width": 120
    }
  }, [_c('ElSwitch', {
    model: {
      value: (_vm.askForTch),
      callback: function($$v) {
        _vm.askForTch = $$v
      },
      expression: "askForTch"
    }
  })], 1), _vm._v(" "), (_vm.askForTch) ? [_c('Form-item', {
    attrs: {
      "label": "对学生描述：",
      "label-width": 120
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "mini",
      "max": 3
    },
    model: {
      value: (_vm.followFormData.stuDescCheckGroup),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "stuDescCheckGroup", $$v)
      },
      expression: "followFormData.stuDescCheckGroup"
    }
  }, _vm._l((_vm.$constant.stuDesc), function(item) {
    return _c('el-checkbox', {
      key: item.code,
      attrs: {
        "label": item.code,
        "border": ""
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                  ")])
  }), 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "label": "对老师要求：",
      "label-width": 120
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "size": "mini",
      "max": 5
    },
    model: {
      value: (_vm.followFormData.askForTchCheckGroup),
      callback: function($$v) {
        _vm.$set(_vm.followFormData, "askForTchCheckGroup", $$v)
      },
      expression: "followFormData.askForTchCheckGroup"
    }
  }, _vm._l((_vm.$constant.askForTch), function(item) {
    return _c('el-checkbox', {
      key: item.code,
      attrs: {
        "label": item.code,
        "border": ""
      }
    }, [_vm._v("\n                    " + _vm._s(item.text) + "\n                  ")])
  }), 1)], 1)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "0 0 40px 35px"
    }
  }, [_c('Button', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addFollow
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary"
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-bottom": "15px",
      "margin-left": "30px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("follow up记录")])], 1), _vm._v(" "), _c('Table', {
    staticStyle: {
      "margin-left": "30px",
      "margin-right": "30px"
    },
    attrs: {
      "border": "",
      "columns": _vm.followtitle,
      "data": _vm.followData,
      "reload": _vm.reload
    }
  })], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "推荐老师",
      "name": "tree"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openRecommendEdit
    }
  }, [_vm._v("添加老师")]), _vm._v(" "), _c('RecommendList', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "uid": _vm.formData.uid,
      "listUrl": "/tchRecommend/list",
      "tableColumns": _vm.recommendTitle,
      "reset": _vm.reset,
      "data": _vm.recommendData
    }
  })], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "阶段报告",
      "name": "four"
    }
  }, [_c('Table', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "border": "",
      "columns": _vm.stageReportTitle,
      "data": _vm.stageReportData,
      "reload": _vm.reload
    }
  })], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "学生跟踪记录",
      "name": "five"
    }
  }, [_c('Form', {
    ref: "form",
    staticClass: "form",
    attrs: {
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 90
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生ID"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "maxlength": 10,
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.uid),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "uid", _vm._n($$v))
      },
      expression: "formValidate.uid"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生姓名",
      "prop": "nickname"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读",
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.nickname),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nickname", $$v)
      },
      expression: "formValidate.nickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问",
      "prop": "adviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读",
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.adviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "adviserName", $$v)
      },
      expression: "formValidate.adviserName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导",
      "prop": "studyAdviserName"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "placeholder": "只读",
      "disabled": _vm.disable
    },
    model: {
      value: (_vm.formValidate.studyAdviserName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "studyAdviserName", $$v)
      },
      expression: "formValidate.studyAdviserName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 22,
      "md": 18
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "内容",
      "prop": "content"
    }
  }, [_c('Input', {
    attrs: {
      "type": "textarea",
      "autosize": {
        minRows: 3,
        maxRows: 10
      }
    },
    model: {
      value: (_vm.formValidate.content),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "content", $$v)
      },
      expression: "formValidate.content"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "ghost": "",
      "size": "small",
      "loading": _vm.aiLoading,
      "disabled": _vm.aiLoading
    },
    on: {
      "click": _vm.handleAiMarkdown
    }
  }, [_vm._v("AI 处理")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "8px",
      "color": "#999",
      "font-size": "12px"
    }
  }, [_vm._v("将通话/听记原文清洗为结构化 Markdown")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系日期"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "date",
      "clearable": false
    },
    on: {
      "on-change": _vm.nextTimeDateChange
    },
    model: {
      value: (_vm.formValidate.nextTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nextTimeDate", $$v)
      },
      expression: "formValidate.nextTimeDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "下次联系人"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formValidate.nextHandlerId),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "nextHandlerId", _vm._n($$v))
      },
      expression: "formValidate.nextHandlerId"
    }
  }, _vm._l((_vm.nextHandler), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.nickname) + "\n                  ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "记录属性",
      "prop": "traceType"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.formValidate.traceType),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "traceType", $$v)
      },
      expression: "formValidate.traceType"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("新注册学生")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("分配记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "21"
    }
  }, [_vm._v("试听课记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "31"
    }
  }, [_vm._v("成交记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "41"
    }
  }, [_vm._v("交接记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "51"
    }
  }, [_vm._v("绑定记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "61"
    }
  }, [_vm._v("上课跟进记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "71"
    }
  }, [_vm._v("转介绍跟进记录")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "99"
    }
  }, [_vm._v("其他")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "sm": 11,
      "md": 5
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上传截图",
      "prop": "url"
    }
  }, [_c('multiple-image-upload', {
    attrs: {
      "num": 100,
      "defaultFileList": _vm.defaultPicList,
      "on-file-change": "onFileChange"
    },
    model: {
      value: (_vm.formValidate.files),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "files", $$v)
      },
      expression: "formValidate.files"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Form-item', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('div', [_c('table', {
    staticClass: "track-list",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "width": "4%"
    }
  }, [_vm._v("序号")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("记录属性")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "16%"
    }
  }, [_vm._v("添加时间")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "40%"
    }
  }, [_vm._v("内容")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("下次联系日期")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("下次联系人")]), _vm._v(" "), _c('th', {
    attrs: {
      "width": "10%"
    }
  }, [_vm._v("操作人")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.tableData), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      attrs: {
        "rowspan": item.rowSpan,
        "hidden": item.hidden
      }
    }, [_vm._v(_vm._s(item.showName))]), _vm._v(" "), _c('td', [_c('span', [_vm._v(_vm._s(item.createTime))])]), _vm._v(" "), _c('td', [_c('TrackContentPreview', {
      attrs: {
        "content": item.content
      },
      on: {
        "view": function($event) {
          return _vm.openTrackContent(item)
        }
      }
    }, [(item.showName == '注册学员备注' && item.nickname && item.nickname.trim() !== '') ? _c('a', {
      staticStyle: {
        "margin-left": "8px"
      },
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.viewPic(item)
        }
      }
    }, [_vm._v("查看图片")]) : _vm._e()])], 1), _vm._v(" "), (item.nextHandlerTime == '0000-00-00 00:00:00') ? _c('td', [_vm._v(_vm._s(item.nextHandlerTime))]) : _c('td', [_vm._v("0")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.nextHandlerName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.createName))])])
  }), 0)]), _vm._v(" "), _c('Page', {
    attrs: {
      "total": _vm.traceParam.totalCount,
      "show-elevator": "",
      "className": "page",
      "current": _vm.traceParam.pageIndex,
      "pageSize": _vm.traceParam.pageSize,
      "show-total": ""
    },
    on: {
      "on-change": _vm.changePageIndex
    }
  })], 1)], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "订单合同",
      "name": "six"
    }
  }, [_c('RecommendList', {
    attrs: {
      "reload": _vm.reload_fundPackage,
      "uid": _vm.formData.uid,
      "listUrl": "/fundPackage/list",
      "tableColumns": _vm.fundPackageTitle,
      "reset": _vm.fundPackageRest,
      "data": _vm.fundPackageData
    }
  })], 1), _vm._v(" "), _c('TabPane', {
    attrs: {
      "label": "课时统计",
      "name": "seven"
    }
  }, [(_vm.formData.tchChannel === 1) ? _c('Table', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "border": "",
      "columns": _vm.courseTypeTitle,
      "data": _vm.courseTypeData
    }
  }) : _vm._e(), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "2px solid #f0f0f0",
      "margin-bottom": "20px",
      "margin-top": "20px"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "search",
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchWithPage.apply(null, arguments)
      }
    }
  }, [_c('Form', {
    attrs: {
      "label-width": 60,
      "show-message": false
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "上课时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startTimeDateChange
    },
    model: {
      value: (_vm.lessonParams.startTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "startTimeDate", $$v)
      },
      expression: "lessonParams.startTimeDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endTimeDateChange
    },
    model: {
      value: (_vm.lessonParams.endTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "endTimeDate", $$v)
      },
      expression: "lessonParams.endTimeDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学导"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "studyAdviserNickname"
    },
    model: {
      value: (_vm.lessonParams.studyAdviserNickname),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "studyAdviserNickname", $$v)
      },
      expression: "lessonParams.studyAdviserNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问昵称",
      "label-width": 85
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "adviserNickname"
    },
    model: {
      value: (_vm.lessonParams.adviserNickname),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "adviserNickname", $$v)
      },
      expression: "lessonParams.adviserNickname"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师ID"
    }
  }, [_c('Input', {
    attrs: {
      "name": "tchId"
    },
    model: {
      value: (_vm.lessonParams.tchId),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "tchId", $$v)
      },
      expression: "lessonParams.tchId"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师姓名"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "tchName"
    },
    model: {
      value: (_vm.lessonParams.tchName),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "tchName", $$v)
      },
      expression: "lessonParams.tchName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "排课时间"
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.startCreateTimeChange
    },
    model: {
      value: (_vm.lessonParams.startCreateDate),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "startCreateDate", $$v)
      },
      expression: "lessonParams.startCreateDate"
    }
  })], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": "2"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "11"
    }
  }, [_c('Date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期"
    },
    on: {
      "on-change": _vm.endCreateTimeChange
    },
    model: {
      value: (_vm.lessonParams.endCreateDate),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "endCreateDate", $$v)
      },
      expression: "lessonParams.endCreateDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类别",
      "label-width": 80
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.searchWithPage
    },
    model: {
      value: (_vm.lessonParams.courseType),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "courseType", _vm._n($$v))
      },
      expression: "lessonParams.courseType"
    }
  }, _vm._l((_vm.$constant.courseType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                    ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.searchWithPage
    },
    model: {
      value: (_vm.lessonParams.lsnSelStatus),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "lsnSelStatus", _vm._n($$v))
      },
      expression: "lessonParams.lsnSelStatus"
    }
  }, _vm._l((_vm.$constant.lsnSelStatus), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                    ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "老师类型",
      "label-width": 80
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.searchWithPage
    },
    model: {
      value: (_vm.lessonParams.tchCategory),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "tchCategory", _vm._n($$v))
      },
      expression: "lessonParams.tchCategory"
    }
  }, _vm._l((_vm.$constant.teacherCategory), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                    ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程类型",
      "label-width": 80
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.searchWithPage
    },
    model: {
      value: (_vm.lessonParams.lsnType),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "lsnType", _vm._n($$v))
      },
      expression: "lessonParams.lsnType"
    }
  }, _vm._l((_vm.$constant.bookLessonOpenedLsnType), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                    ")])
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('Row', [_c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教材版本"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "请选择",
      "clearable": ""
    },
    on: {
      "on-change": _vm.searchWithPage
    },
    model: {
      value: (_vm.lessonParams.materialVersionId),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "materialVersionId", _vm._n($$v))
      },
      expression: "lessonParams.materialVersionId"
    }
  }, _vm._l((_vm.$constant.materialVersions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v("\n                      " + _vm._s(item.text) + "\n                    ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "是否分配学导",
      "label-width": 100
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "全部",
      "clearable": ""
    },
    on: {
      "on-change": _vm.searchWithPage
    },
    model: {
      value: (_vm.lessonParams.isStudyAdviser),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "isStudyAdviser", _vm._n($$v))
      },
      expression: "lessonParams.isStudyAdviser"
    }
  }, [_c('Option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("已分配")]), _vm._v(" "), _c('Option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("未分配")])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "创建人"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "支持模糊搜索",
      "name": "creatorName"
    },
    model: {
      value: (_vm.lessonParams.creatorName),
      callback: function($$v) {
        _vm.$set(_vm.lessonParams, "creatorName", $$v)
      },
      expression: "lessonParams.creatorName"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 50
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.searchLoading,
      "disable": _vm.searchLoading,
      "icon": "search"
    },
    on: {
      "click": _vm.searchWithPage
    }
  }, [_vm._v("搜索\n                  ")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error",
      "icon": "plus-round"
    },
    on: {
      "click": _vm.openUserClassHourModal
    }
  }, [_vm._v("加减课时")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "error"
    },
    on: {
      "click": _vm.cancelAllClass
    }
  }, [_vm._v("取消全部排课")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('RecommendList', {
    ref: "bookLessonList",
    attrs: {
      "onLoading": _vm.onLessonLoading,
      "params": _vm.lessonParams,
      "uid": _vm.formData.uid,
      "listUrl": "/bookLesson/opened/listByUid",
      "tableColumns": _vm.bookLessonTitle,
      "reloadWithPage": _vm.reloadWithPage,
      "reset": _vm.bookLessonReset
    }
  })], 1), _vm._v(" "), (_vm.detailTabsReady && _vm.showWo) ? _c('TabPane', {
    attrs: {
      "label": "交接工单",
      "name": "eight"
    }
  }, [_c('Form', {
    ref: "woFormData",
    staticClass: "form",
    attrs: {
      "model": _vm.woFormData.saleWo,
      "rules": _vm.woRule
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-left": "30px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("交接工单")])], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生：",
      "label-width": 120
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.woFormData.saleWo.studentId) + " -- " + _vm._s(_vm.woFormData.saleWo.studentName))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "年龄：",
      "label-width": 80
    }
  }, [(_vm.woFormData.saleWo.age > 0) ? _c('label', [_vm._v(_vm._s(_vm.woFormData.saleWo.age))]) : _vm._e(), _vm._v(" "), (_vm.woFormData.saleWo.age === 0) ? _c('label') : _vm._e()])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "9"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "绑定老师：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.woFormData.saleWo.teacherName))])])], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "订单类型：",
      "label-width": 120
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.woFormData.saleWo.orderChannel.text))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "课程顾问：",
      "label-width": 80
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.woFormData.saleWo.adviserName))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "付款金额：",
      "prop": "payAmount",
      "label-width": 80
    }
  }, [_c('Input', {
    attrs: {
      "readonly": _vm.woReadonly,
      "name": "payAmount"
    },
    model: {
      value: (_vm.woFormData.saleWo.payAmount),
      callback: function($$v) {
        _vm.$set(_vm.woFormData.saleWo, "payAmount", _vm._n($$v))
      },
      expression: "woFormData.saleWo.payAmount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    staticStyle: {
      "padding-left": "0"
    },
    attrs: {
      "span": "6"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "工单版本：",
      "label-width": "120"
    }
  }, [(!_vm.woDisable) ? _c('CheckboxGroup', {
    on: {
      "on-change": _vm.clickWoVersion
    },
    model: {
      value: (_vm.woVersion),
      callback: function($$v) {
        _vm.woVersion = $$v
      },
      expression: "woVersion"
    }
  }, [_c('Checkbox', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("新版")])], 1) : _vm._e(), _vm._v(" "), (_vm.woDisable && _vm.woVersion === '1') ? _c('label', [_vm._v("新版")]) : _vm._e(), _vm._v(" "), (_vm.woDisable && _vm.woVersion !== '1') ? _c('label', [_vm._v("旧版")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.woVersion === '1') ? _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "不可用时间：",
      "prop": "disableTime",
      "label-width": "120"
    }
  }, [(!_vm.woDisable) ? _c('Row', {
    attrs: {
      "gutter": 8
    }
  }, [_c('i-col', {
    attrs: {
      "span": 2
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "disableWeek"
    }
  }, [_c('Select', {
    attrs: {
      "placeholder": "星期",
      "transfer": "",
      "disabled": _vm.woDisable
    },
    model: {
      value: (_vm.disableTimeParams.disableWeek),
      callback: function($$v) {
        _vm.$set(_vm.disableTimeParams, "disableWeek", $$v)
      },
      expression: "disableTimeParams.disableWeek"
    }
  }, _vm._l((_vm.$constant.weekSelect), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text) + "\n                        ")])
  }), 1)], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "disableStartTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "type": "date",
      "format": "HH:mm",
      "placeholder": "开始时间",
      "steps": [1, 5],
      "clearable": false,
      "value": _vm.disableTimeParams.disableStartTimeStr,
      "disabled": _vm.woDisable
    },
    on: {
      "on-change": _vm.onChangeDisableStartTime
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 4
    }
  }, [_c('Form-item', {
    attrs: {
      "prop": "disableEndTime"
    }
  }, [_c('Time-picker', {
    attrs: {
      "type": "date",
      "format": "HH:mm",
      "placeholder": "结束时间",
      "steps": [1, 5],
      "clearable": false,
      "value": _vm.disableTimeParams.disableEndTimeStr,
      "disabled": _vm.woDisable
    },
    on: {
      "on-change": _vm.onChangeDisableEndTime
    }
  })], 1)], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": 2
    }
  }, [_c('Button', {
    attrs: {
      "type": "info",
      "disabled": _vm.woDisable
    },
    on: {
      "click": _vm.addDisableTime
    }
  }, [_vm._v("添加")])], 1)], 1) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.woVersion === '1') ? _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('i-col', {
    attrs: {
      "span": 24
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "已选择：",
      "prop": "disableTimeList",
      "label-width": "120"
    }
  }, [_c('Row', _vm._l((_vm.disableTimeList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('Col', {
      attrs: {
        "span": "22"
      }
    }, [_c('label', [_c('b', [_vm._v("    " + _vm._s(item.disableWeekStr) + "       \n                        " + _vm._s(item.disableStartTimeStr) + "    --    \n                        " + _vm._s(item.disableEndTimeStr) + "    \n                      ")])]), _vm._v(" "), (!_vm.woDisable) ? _c('Button', {
      attrs: {
        "type": "error",
        "size": "small",
        "disabled": _vm.woDisable
      },
      on: {
        "click": function($event) {
          return _vm.removeDisableTime(index)
        }
      }
    }, [_vm._v("删除\n                      ")]) : _vm._e()], 1)], 1)
  }), 0)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "备注：",
      "prop": "remark",
      "label-width": 120
    }
  }, [_c('Input', {
    staticStyle: {
      "width": "500px"
    },
    attrs: {
      "readonly": _vm.woReadonly,
      "type": "textarea",
      "rows": 4,
      "placeholder": "请输入..."
    },
    model: {
      value: (_vm.woFormData.saleWo.remark),
      callback: function($$v) {
        _vm.$set(_vm.woFormData.saleWo, "remark", $$v)
      },
      expression: "woFormData.saleWo.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "状态：",
      "label-width": 120
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.woFormData.saleWo.woStatus.text))])])], 1), _vm._v(" "), _c('i-col', {
    attrs: {
      "span": "10"
    }
  }, [_c('Form-item', {
    attrs: {
      "label-width": 50
    }
  }, [(!_vm.woReadonly) ? _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.woSubmitLoading,
      "disable": _vm.woSubmitLoading
    },
    on: {
      "click": function($event) {
        return _vm.saveWoData()
      }
    }
  }, [_vm._v("保存\n                ")]) : _vm._e(), _vm._v(" "), (!_vm.woReadonly) ? _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.woSubmitLoading,
      "disable": _vm.woSubmitLoading
    },
    on: {
      "click": function($event) {
        return _vm.submitWoData()
      }
    }
  }, [_vm._v("提交工单\n                ")]) : _vm._e(), _vm._v(" "), (_vm.woFormData.saleWo.status === 'UNAUDITED' || _vm.woFormData.saleWo.status === 'APPROVED') ? _c('Button', {
    attrs: {
      "type": "primary",
      "loading": _vm.woSubmitLoading,
      "disable": _vm.woSubmitLoading
    },
    on: {
      "click": function($event) {
        return _vm.rollbackWoData()
      }
    }
  }, [_vm._v("撤销工单\n                ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (_vm.woVersion !== '1') ? _c('Row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "首次开课时间：",
      "prop": "classOpeningTime",
      "label-width": 120
    }
  }, [_c('DatePicker', {
    attrs: {
      "readonly": _vm.woReadonly,
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "请选择日期",
      "transfer": ""
    },
    model: {
      value: (_vm.woFormData.saleWo.classOpeningTime),
      callback: function($$v) {
        _vm.$set(_vm.woFormData.saleWo, "classOpeningTime", $$v)
      },
      expression: "woFormData.saleWo.classOpeningTime"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('Row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('Tag', {
    staticStyle: {
      "margin-bottom": "15px",
      "margin-left": "30px"
    },
    attrs: {
      "color": "yellow"
    }
  }, [_vm._v("工单记录")])], 1), _vm._v(" "), _c('Table', {
    staticStyle: {
      "margin-left": "30px",
      "margin-right": "30px"
    },
    attrs: {
      "border": "",
      "columns": _vm.woFollowTitle,
      "data": _vm.woFormData.follows,
      "reload": _vm.reload
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.detailTabsReady && _vm.formData.tchChannel === 2) ? _c('TabPane', {
    attrs: {
      "label": "用户权益",
      "name": "nine"
    }
  }, [_c('Table', {
    staticStyle: {
      "margin-top": "10px"
    },
    attrs: {
      "border": "",
      "columns": _vm.courseHourTitle,
      "data": _vm.classHourListData
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('RecommendTeacher', {
    attrs: {
      "value": _vm.recommendEdit,
      "uid": _vm.formData.uid
    },
    on: {
      "on-close": _vm.closeRecommendEdit
    }
  }), _vm._v(" "), _c('StageReportModal', {
    attrs: {
      "uid": _vm.formData.uid,
      "successCallback": _vm.reportList
    },
    model: {
      value: (_vm.StageReportModal),
      callback: function($$v) {
        _vm.StageReportModal = $$v
      },
      expression: "StageReportModal"
    }
  }), _vm._v(" "), _c('EvaluationSheetModal', {
    attrs: {
      "reprotId": _vm.reprotId,
      "successCallback": _vm.reportList
    },
    on: {
      "on-close": _vm.onEvaluationSheetModalClose
    },
    model: {
      value: (_vm.showEvaluationSheetModal),
      callback: function($$v) {
        _vm.showEvaluationSheetModal = $$v
      },
      expression: "showEvaluationSheetModal"
    }
  }), _vm._v(" "), _c('BookUserFeedbackModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    on: {
      "on-close": _vm.onBookUserFeedBackClose
    },
    model: {
      value: (_vm.showBookUserFeedbackModal),
      callback: function($$v) {
        _vm.showBookUserFeedbackModal = $$v
      },
      expression: "showBookUserFeedbackModal"
    }
  }), _vm._v(" "), _c('BookTchFeedbackModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    on: {
      "on-close": _vm.onBookTchFeedBackClose
    },
    model: {
      value: (_vm.showBookTchFeedbackModal),
      callback: function($$v) {
        _vm.showBookTchFeedbackModal = $$v
      },
      expression: "showBookTchFeedbackModal"
    }
  }), _vm._v(" "), _c('BookTchScoreFeedbackModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    on: {
      "on-close": _vm.onBookTchScoreFeedBackClose
    },
    model: {
      value: (_vm.showBookTchScoreFeedbackModal),
      callback: function($$v) {
        _vm.showBookTchScoreFeedbackModal = $$v
      },
      expression: "showBookTchScoreFeedbackModal"
    }
  }), _vm._v(" "), _c('ClassMemberTimeModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    on: {
      "on-close": _vm.onClassMemberClose
    },
    model: {
      value: (_vm.showClassMemberTimeModal),
      callback: function($$v) {
        _vm.showClassMemberTimeModal = $$v
      },
      expression: "showClassMemberTimeModal"
    }
  }), _vm._v(" "), _c('ChangeLessonModal', {
    attrs: {
      "lessonOpened": _vm.lessonOpened,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showChangeLessonModal),
      callback: function($$v) {
        _vm.showChangeLessonModal = $$v
      },
      expression: "showChangeLessonModal"
    }
  }), _vm._v(" "), _c('UserOneLeaveModal', {
    attrs: {
      "openId": _vm.openId,
      "title": _vm.lessonTitle,
      "beginTime": _vm.lsnBeginTime,
      "successCallback": _vm.searchWithPage
    },
    on: {
      "on-close": _vm.closeModal
    },
    model: {
      value: (_vm.showUserOneLeaveModal),
      callback: function($$v) {
        _vm.showUserOneLeaveModal = $$v
      },
      expression: "showUserOneLeaveModal"
    }
  }), _vm._v(" "), _c('TchLessonLeaveModal', {
    attrs: {
      "openedId": _vm.openedId,
      "title": _vm.lessonTitle,
      "beginTime": _vm.lsnBeginTime,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showTchLessonLeaveModal),
      callback: function($$v) {
        _vm.showTchLessonLeaveModal = $$v
      },
      expression: "showTchLessonLeaveModal"
    }
  }), _vm._v(" "), _c('LessonCancelModal', {
    attrs: {
      "openedId": _vm.openedId,
      "lsnType": _vm.lsnType,
      "tchChannel": _vm.formData.tchChannel,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showLessonCancelModal),
      callback: function($$v) {
        _vm.showLessonCancelModal = $$v
      },
      expression: "showLessonCancelModal"
    }
  }), _vm._v(" "), _c('BalanceModal', {
    attrs: {
      "openedId": _vm.openedId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showBalanceModal),
      callback: function($$v) {
        _vm.showBalanceModal = $$v
      },
      expression: "showBalanceModal"
    }
  }), _vm._v(" "), _c('RejectBalanceModal', {
    attrs: {
      "openedId": _vm.openedId,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showRejectBalanceModal),
      callback: function($$v) {
        _vm.showRejectBalanceModal = $$v
      },
      expression: "showRejectBalanceModal"
    }
  }), _vm._v(" "), _c('MonitorLessonRecordListModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    model: {
      value: (_vm.showMonitorLessonRecordListModal),
      callback: function($$v) {
        _vm.showMonitorLessonRecordListModal = $$v
      },
      expression: "showMonitorLessonRecordListModal"
    }
  }), _vm._v(" "), _c('UserClassHourModal', {
    attrs: {
      "uid": _vm.formData.uid
    },
    model: {
      value: (_vm.showUserClassHourModal),
      callback: function($$v) {
        _vm.showUserClassHourModal = $$v
      },
      expression: "showUserClassHourModal"
    }
  }), _vm._v(" "), _c('AddMonitorLessonRecordModal', {
    attrs: {
      "openedId": _vm.openedId
    },
    model: {
      value: (_vm.showMonitorLessonRecordModal),
      callback: function($$v) {
        _vm.showMonitorLessonRecordModal = $$v
      },
      expression: "showMonitorLessonRecordModal"
    }
  }), _vm._v(" "), _c('StudentWriteReviewDemoModal', {
    attrs: {
      "openedId": _vm.openedId,
      "reviewState": _vm.reviewState,
      "value": _vm.studentWriteReviewDemoModal,
      "formData": _vm.studentWriteReviewDemoModalFormData
    },
    on: {
      "on-close": _vm.closeReviewModal
    }
  }), _vm._v(" "), _c('StudentWriteReviewDemoV2Modal', {
    attrs: {
      "openedId": _vm.openedId,
      "reviewState": _vm.reviewState,
      "value": _vm.studentWriteReviewDemoV2Modal,
      "formData": _vm.studentWriteReviewDemoV2ModalFormData
    },
    on: {
      "on-close": _vm.closeReviewModal
    }
  }), _vm._v(" "), _c('StudentWriteReviewRegularModal', {
    attrs: {
      "openedId": _vm.openedId,
      "reviewState": _vm.reviewState,
      "value": _vm.studentWriteReviewRegularModal,
      "formData": _vm.studentWriteReviewRegularModalFormData
    },
    on: {
      "on-close": _vm.closeReviewModal
    }
  }), _vm._v(" "), _c('StudentWriteReviewRegularV2Modal', {
    attrs: {
      "openedId": _vm.openedId,
      "reviewState": _vm.reviewState,
      "value": _vm.studentWriteReviewRegularV2Modal,
      "formData": _vm.studentWriteReviewRegularV2ModalFormData
    },
    on: {
      "on-close": _vm.closeReviewModal
    }
  }), _vm._v(" "), _c('StudentWriteReviewFinishLevelModal', {
    attrs: {
      "openedId": _vm.openedId,
      "reviewState": _vm.reviewState,
      "value": _vm.studentWriteReviewFinishLevelModal,
      "formData": _vm.studentWriteReviewFinishLevelModalFormData
    },
    on: {
      "on-close": _vm.closeReviewModal
    }
  }), _vm._v(" "), _c('StudentWriteReviewFinishLevelV2Modal', {
    attrs: {
      "openedId": _vm.openedId,
      "reviewState": _vm.reviewState,
      "value": _vm.studentWriteReviewFinishLevelV2Modal,
      "formData": _vm.studentWriteReviewFinishLevelV2ModalFormData
    },
    on: {
      "on-close": _vm.closeReviewModal
    }
  }), _vm._v(" "), _c('SearchChangeTchModal', {
    attrs: {
      "optType": _vm.optType,
      "user": _vm.tempLessonUser,
      "changeTeacherOnly": _vm.changeTeacherOnly,
      "successCallback": _vm.searchWithPage
    },
    model: {
      value: (_vm.showSearchChangeTchModal),
      callback: function($$v) {
        _vm.showSearchChangeTchModal = $$v
      },
      expression: "showSearchChangeTchModal"
    }
  }), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "修改版本号"
    },
    model: {
      value: (_vm.showVersionModel),
      callback: function($$v) {
        _vm.showVersionModel = $$v
      },
      expression: "showVersionModel"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.needversion),
      callback: function($$v) {
        _vm.needversion = $$v
      },
      expression: "needversion"
    }
  }, [_c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("版本一")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "2"
    }
  }, [_vm._v("版本二")]), _vm._v(" "), _c('Option', {
    key: "3",
    attrs: {
      "value": "3"
    }
  }, [_vm._v("版本三")]), _vm._v(" "), _c('Option', {
    key: "4",
    attrs: {
      "value": "4"
    }
  }, [_vm._v("版本四")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showVersionModel = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.saveVersion
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "修改合同状态"
    },
    model: {
      value: (_vm.showContractStatusModel),
      callback: function($$v) {
        _vm.showContractStatusModel = $$v
      },
      expression: "showContractStatusModel"
    }
  }, [_c('Select', {
    model: {
      value: (_vm.needContractStatus),
      callback: function($$v) {
        _vm.needContractStatus = $$v
      },
      expression: "needContractStatus"
    }
  }, [_c('Option', {
    key: "0",
    attrs: {
      "value": "0"
    }
  }, [_vm._v("使用中")]), _vm._v(" "), _c('Option', {
    key: "1",
    attrs: {
      "value": "1"
    }
  }, [_vm._v("未开启")]), _vm._v(" "), _c('Option', {
    key: "2",
    attrs: {
      "value": "2"
    }
  }, [_vm._v("已过期")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.showContractStatusModel = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.saveContractStatus
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('ShowImageCarousel', {
    attrs: {
      "imgList": _vm.showImgList,
      "value": _vm.showImgModal
    },
    on: {
      "on-close": _vm.closeImgModal
    }
  }), _vm._v(" "), _c('UserTrackContentModal', {
    ref: "trackContentModal"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-565acd4d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserPayDetail.vue
// module id = 1821
// module chunks = 8